import React from 'react';
import EmojiPickerReact from 'emoji-picker-react';

// Full emoji library (search, categories, skin tones, recently used) from `emoji-picker-react`.
// Kept identical in the admin panel and the member site.
const currentTheme = () => {
    const root = document.documentElement;
    const adminDark = root.dataset.adminTheme === 'dark';
    const siteDark = root.dataset.theme === 'dark';
    return adminDark || siteDark ? 'dark' : 'light';
};

const EmojiPicker = ({ onPick }) => (
    <div className="emoji-picker emoji-picker--full" role="dialog" aria-label="Emoji picker">
        <EmojiPickerReact
            onEmojiClick={data => onPick(data.emoji)}
            theme={currentTheme()}
            width="100%"
            height={380}
            lazyLoadEmojis
            searchPlaceholder="Search emoji"
            previewConfig={{ showPreview: false }}
        />
    </div>
);

export default EmojiPicker;
